import React, { PureComponent } from "react";
import { Col } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import PropTypes from "prop-types";

class SendMessageForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  state = {
    first_name: "",
    last_name: "",
    company: "",
    email: "",
  };

  componentDidMount() {
    this.props.initialize(this.props.edit());
    this.setState(this.props.edit());
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState({
      showPassword: !this.state.showPassword,
    });
  };

  cancelCreation = () => {
    this.props.reset();
    this.props.cancelCreation();
  };

  formChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    this.setState({ [nam]: val }, () => {
      this.props.handleForm(this.state);
    });
  };

  render() {
    const { handleSubmit } = this.props;

    return (
      <Col md={12} lg={12}>
        <div className="card__title">
          <h5 className="bold-text">{this.props.title}</h5>
        </div>
        <form
          autoComplete="off"
          className="form form--horizontal"
          onSubmit={handleSubmit}
        >
          <div className="form__form-group">
            <span className="form__form-group-label">Message</span>
            <div className="form__form-group-field">
              <Field
                name="content"
                component="textarea"
                type="textarea"
                placeholder="Message"
                onKeyUp={this.formChangeHandler}
              />
            </div>
          </div>
        </form>
      </Col>
    );
  }
}

SendMessageForm = reduxForm({
  // a unique name for the form
  form: "users_form_send_message",
})(SendMessageForm);

export default SendMessageForm;
